import { useEffect, useLayoutEffect, useRef, useState } from 'react'

function useStableSyncMentionUi(syncMentionUi) {
  const syncRef = useRef(syncMentionUi)
  syncRef.current = syncMentionUi
  return syncRef
}
import { getComposerPlainText } from './composerSerialize'
import { getSafeEditorDom } from './getSafeEditorDom'

export function useComposerEditorLifecycle({
  editor,
  readOnly,
  textareaMaxHeightPx,
  plainHandlerRef,
  syncMentionUi,
}) {
  const [layoutVersion, setLayoutVersion] = useState(0)
  const syncMentionUiRef = useStableSyncMentionUi(syncMentionUi)

  useEffect(() => {
    if (!editor || editor.isDestroyed) return
    const handleUpdate = () => {
      plainHandlerRef.current?.(getComposerPlainText(editor))
      setLayoutVersion((v) => v + 1)
      syncMentionUiRef.current()
    }
    const handleSelection = () => syncMentionUiRef.current()
    editor.on('update', handleUpdate)
    editor.on('selectionUpdate', handleSelection)
    handleUpdate()
    return () => {
      editor.off('update', handleUpdate)
      editor.off('selectionUpdate', handleSelection)
    }
  }, [editor, syncMentionUiRef, plainHandlerRef])

  useLayoutEffect(() => {
    if (!editor || editor.isDestroyed) return
    const el = getSafeEditorDom(editor)
    if (!el) return
    el.style.height = 'auto'
    el.style.height = `${Math.min(el.scrollHeight, textareaMaxHeightPx)}px`
  }, [editor, textareaMaxHeightPx, layoutVersion])

  useEffect(() => {
    if (!editor || editor.isDestroyed) return
    editor.setEditable(!readOnly)
  }, [editor, readOnly])

  return layoutVersion
}
